import {getTenantCustomImage, getTenantName} from 'common/HelperFunctions'
import Logo from 'common/components/Logo'
import {BUILD_VERSION} from 'common/constants'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, Outlet} from 'react-router'
import {MainReducer, RootState} from 'setup'
import {getGeneralSettings} from 'setup/redux/Actions/General/settings'

import {toAbsoluteUrl} from '_metronic/helpers'

const AuthLayout = () => {
  const dispatch = useDispatch()
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings
  ) as MainReducer['generalSettings']

  const [backgroundUrl, setBackgroundUrl] = useState(toAbsoluteUrl('/media/background/6.png')) // toAbsoluteUrl('media/misc/auth-bg.png')

  const initBackgroundImage = () => {
    const customBackgroundImage = getTenantCustomImage('background_image')
    if (customBackgroundImage) setBackgroundUrl(customBackgroundImage)
    else if (generalSettings.background_image) setBackgroundUrl(generalSettings.background_image)
  }

  useEffect(() => {
    dispatch(getGeneralSettings())
    initBackgroundImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    initBackgroundImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generalSettings])

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
        </div>

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5'>
          <div className='d-flex gap-5 fw-semibold text-primary fs-base'>
            {getTenantName() !== 'lgs' && !!generalSettings?.powered_by_text && (
              <div dangerouslySetInnerHTML={{__html: generalSettings?.powered_by_text}} />
            )}
            <div>Build: {BUILD_VERSION}</div>
          </div>
        </div>
      </div>

      {/* begin::Aside */}
      <div
        className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        style={{backgroundImage: `url(${backgroundUrl})`}}
      >
        {/* begin::Content */}
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          {/* begin::Logo */}
          <Link to='/' className='mb-12'>
            <Logo size='big' />
          </Link>
          {/* end::Logo */}

          {/* begin::Image */}
          {/* <img
            className='mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20'
            src={toAbsoluteUrl('media/misc/auth-screens.png')}
            alt=''
          /> */}
          {/* end::Image */}

          {/* begin::Title */}
          {/* <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
            Fast, Efficient and Productive
          </h1> */}
          {/* end::Title */}

          {/* begin::Text */}
          {/* <div className='text-white fs-base text-center'>
            In this kind of post,{' '}
            <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
              the blogger
            </a>
            introduces a person they’ve interviewed <br /> and provides some background information
            about
            <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
              the interviewee
            </a>
            and their <br /> work following this is a transcript of the interview.
          </div> */}
          {/* end::Text */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
